// Rastro de gravações (levantamento de 02/10, item A4: o app não se atualizava).
//
// POR QUE EXISTE: para o store recarregar os dados sozinho sem perigo. Uma recarga que LÊ o banco no meio de uma
// GRAVAÇÃO pode trazer o dado velho e, ao ser aplicada, desfazer na tela o que a pessoa acabou de salvar. O store
// precisa saber (1) se há gravação em andamento, para adiar a recarga, e (2) se uma gravação aconteceu durante uma
// leitura, para descartar a leitura. As ações do store são 100+ e cada uma chama a api por conta própria; em vez
// de mexer em todas, a api é embrulhada aqui, num lugar só.
//
// REGRA: o que devolve promessa e não começa com um prefixo de leitura é uma GRAVAÇÃO. Errar para o lado "é
// gravação" só adia uma recarga; errar para o outro lado deixaria o dado velho sobrescrever o novo.
//
// Fica fora de `src/data/api.js` de propósito: o store não pode importá-lo (CLAUDE.md, seção 5); recebe a api por prop.

const LEITURA = /^(listar|buscar|obter|consultar|ler|carregar)/;

/** `pendentes`: gravações em andamento. `geracao`: sobe quando uma gravação COMEÇA e quando TERMINA. */
export const criarRastro = () => ({ pendentes: 0, geracao: 0 });

export function rastrearEscritas(api, rastro) {
  if (!api) return api;
  // Proxy, e não uma cópia: os testes (e a tela de demonstração) acrescentam ou trocam métodos depois da montagem.
  return new Proxy(api, {
    get(alvo, nome) {
      const valor = Reflect.get(alvo, nome, alvo);
      if (typeof valor !== 'function' || typeof nome !== 'string') return valor;
      if (LEITURA.test(nome)) return valor.bind(alvo);
      return (...args) => {
        const retorno = valor.apply(alvo, args);
        if (!retorno || typeof retorno.then !== 'function') return retorno; // função síncrona (tradutor): não é gravação
        rastro.pendentes += 1;
        rastro.geracao += 1;
        const terminou = () => { rastro.pendentes -= 1; rastro.geracao += 1; };
        return retorno.then(
          (v) => { terminou(); return v; },
          (e) => { terminou(); throw e; },
        );
      };
    },
  });
}
